import { useEffect } from 'react';

export const useDisableLastPassExtension = ({
  parentElementName,
  childrenElementName,
}: {
  parentElementName: string;
  childrenElementName?: string;
}) => {
  useEffect(() => {
    const observer = new MutationObserver(mutationsList => {
      // Iterate over mutations to check if 'data-lastpass-root' is added to the DOM
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const lastPassParentElement = document?.querySelector(`[${parentElementName}]`);
          const lastPassChildrenElements = document?.querySelectorAll(`[${childrenElementName}]`);

          if (lastPassParentElement) {
            // Element has appeared in the DOM, remove it
            lastPassParentElement.remove();
          } else if (lastPassChildrenElements) {
            // hide LastPass red icons inside input field
            lastPassChildrenElements.forEach(element => {
              if (element instanceof HTMLElement) {
                element.style.display = 'none';
              }
            });
          }
        }
      }
    });

    // Set up the observer to watch for child additions/ removals in the body or a specific container
    observer.observe(document.body, { childList: true, subtree: true });

    // Cleanup observer on component unmount
    return () => {
      observer.disconnect();
    };
  }, [parentElementName, childrenElementName]);
};
